var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-page-not-found-simple" },
    [
      _c("div", { staticClass: "vuestic-page-not-found-simple__content" }, [
        _c(
          "div",
          { staticClass: "vuestic-page-not-found-simple__wallpaper" },
          [
            _c("router-link", {
              staticClass: "i-vuestic vuestic-page-not-found-simple__i-vuestic",
              attrs: { to: { path: "/" } },
            }),
          ],
          1
        ),
        _vm._m(0),
        _vm._m(1),
        _c(
          "div",
          {
            staticClass:
              "vuestic-page-not-found-simple__wallpaper-button flex md12",
          },
          [
            _c("router-link", { attrs: { to: { path: "./dashboard" } } }, [
              _c("button", { staticClass: "btn btn-primary back-button" }, [
                _vm._v(
                  "\n          " + _vm._s("Back to dashboard") + "\n        "
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c("vuestic-page-not-found-sad-wallpaper"),
      _c("made-by-component"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "vuestic-page-not-found-simple__wallpaper" },
      [
        _c("h3", { staticClass: "vuestic-page-not-found-simple__text" }, [
          _vm._v("The page's gone\n        fishing."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "vuestic-page-not-found-simple__wallpaper flex md12" },
      [
        _c(
          "div",
          { staticClass: "va-row vuestic-page-not-found-simple__message" },
          [
            _c(
              "h4",
              { staticClass: "vuestic-page-not-found-simple__text-small" },
              [
                _vm._v(
                  "If you feel that\n          it's not right, please send us a message at  "
                ),
              ]
            ),
            _c("a", { attrs: { href: "mailto:hello@epicmax.co" } }, [
              _vm._v("hello@epicmax.co"),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }